import React, { useState } from "react";

import {
  Row,
  Col,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

// withRouter
import withRouter from "src/components/Common/withRouter";
// actions
import { loginUser } from "../../slices/thunks";

//import images
import logoDark from "../../assets/images/khozi.png";
import logoLight from "../../assets/images/khozi.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createSelector } from "reselect";

interface LoginProps {
  props: any;
}

const Login = ({ props }: LoginProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  document.title = "Login | Khozi";

  const selectLeadData = createSelector(
    (state: any) => state.login.error,
    leadsChart => leadsChart
  );
  const error = useSelector(selectLeadData);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Por favor introduza o seu nome de utilizador"),
      password: Yup.string().required("Por favor introduza a sua palavra passe"),
    }),
    onSubmit: values => {
      dispatch(loginUser(values, navigate));
    },
  });

  return (
    <React.Fragment>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay bg-white"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3 pt-4">
            <Row className="justify-content-center my-auto">
              <Col md={8} lg={6} xl={4}>
                <div className="text-center py-5">
                  <div className="mb-4 mb-md-5">
                    <Link to="/control-panel" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="120" className="auth-logo-dark"/>
                      <img src={logoLight} alt="" height="120" className="auth-logo-light"/>
                    </Link>
                  </div>
                  <div className="mb-4">
                    <h5>Bem-vindo ao Khozi.</h5>
                  </div>
                  {error && error ? (
                    <Alert className="alert-danger">
                      Nome de utilizador ou palavra passe inválidos
                    </Alert>
                  ) : null}
                  <Form
                    onSubmit={e => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-floating form-floating text-start mb-3">
                      <Input
                        type="text"
                        name="username"
                        className="form-control"
                        id="input-username"
                        placeholder="Introduza o seu nome de utilizador"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username &&
                          validation.errors.username ? true : false
                        }
                      />
                      {validation.touched.username &&
                      validation.errors.username ? (
                        <FormFeedback type="invalid">
                          {validation.errors.username}
                        </FormFeedback>
                      ) : null}
                      <Label htmlFor="input-username">Nome de Utilizador</Label>
                    </div>
                    <div className="form-floating form-floating text-start mb-3">
                      <Input
                        name="password"
                        type="password"
                        className="form-control"
                        id="input-password"
                        placeholder="Introduza a sua palavra passe"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password ? true : false
                        }
                      />
                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback type="invalid">
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                      <Label htmlFor="input-password">Palavra Passe</Label>
                    </div>

                    <div className="form-check form-check-info font-size-16">
                      <Input className="form-check-input" type="checkbox" id="remember-check" />
                      <Label className="form-check-label font-size-14" htmlFor="remember-check">
                        Manter-me conectado
                      </Label>
                    </div>

                    <div className="mt-3">
                      <button className="btn btn-info w-100" type="submit">
                        Entrar
                      </button>
                    </div>

                    <div className="mt-4">
                      <Link to="/auth-resetpassword-basic" className="text-muted text-decoration-underline">
                        Esqueceu a sua senha?
                      </Link>
                    </div>
                  </Form>{" "}
                </div>
              </Col>
            </Row>

            <Row>
              <Col xl={12}>
                <div className="text-center text-muted p-4">
                  <p className="mb-0">
                    &copy; {new Date().getFullYear()} Khozi. Desenvolvido pela{" "}
                    <a href="http://casco.co.mz/" target="_blank" rel="noopener noreferrer">
                      CASCO
                    </a>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
